import { SxProps } from "@mui/material";

export const tableContainer: SxProps = {
  width: "100%",
  maxWidth: "100%",
  overflowX: "hidden",
  backgroundColor: "#fff",
  borderRadius: "5px",
  border: "1px solid rgba(200, 200, 200, 1)",
};
export const table: SxProps = {
  borderStyle: "hidden",
  tableLayout: "fixed",
  width: "100%",
};
export const dotwHeader: SxProps = {
  fontWeight: "bold",
  textAlign: "center",
  padding: "8px",
  "@media (max-width: 480px)": {
    fontSize: "12px",
    padding: "6px 0",
  },
};
export const dayCell: SxProps = {
  padding: "8px",
  textAlign: "center",
  "@media (max-width: 480px)": {
    padding: "6px 0",
  },
};
export const dayNumber: SxProps = {
  fontSize: "18px",
  fontWeight: "bold",
  "@media (max-width: 480px)": {
    fontSize: "14px",
  },
};
